// extracted by mini-css-extract-plugin
export default {"form":"Login_form__5RVzy","input":"Login_input__vHiuq","inputLabel":"Login_inputLabel__-3fId","empty":"Login_empty__94axt","inputField":"Login_inputField__zZYkU"};